import { render, staticRenderFns } from "./EcosystemProgramsMap.vue?vue&type=template&id=23f12161&scoped=true&"
import script from "./EcosystemProgramsMap.vue?vue&type=script&lang=js&"
export * from "./EcosystemProgramsMap.vue?vue&type=script&lang=js&"
import style0 from "./EcosystemProgramsMap.vue?vue&type=style&index=0&id=23f12161&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f12161",
  null
  
)

export default component.exports